import paths from "../../../routes/paths";
import { uploadFileToS3, BUCKET_NAME } from "../../../utils/uploadFileToS3";

const uploadIfFile = async (file, key) => {
  if (!file) return null;
  if (typeof file === "string") return file;

  const res = await uploadFileToS3(BUCKET_NAME, file, key);
  return res.s3Url;
};

export const uploadCibilDocuments = async (cibilCheck, leadId) => {
  const timestamp = Date.now();
  const prefix = `${paths.DRIVER_LEAD_CREATION}/${leadId || "temp"}`;

  const [aadhaarFrontUrl, aadhaarBackUrl, panCardUrl] = await Promise.all([
    uploadIfFile(
      cibilCheck.aadhaarFrontUrl,
      `${prefix}/aadhaar-front-${timestamp}`,
    ),
    uploadIfFile(cibilCheck.aadhaarBackUrl, `${prefix}/aadhaar-back-${timestamp}`),
    uploadIfFile(cibilCheck.panCardUrl, `${prefix}/pan-card-${timestamp}`),
  ]);

  return {
    aadhaarFrontUrl,
    aadhaarBackUrl,
    panCardUrl,
    cibilNumber: cibilCheck.cibilNumber,
  };
};
